export default "__VITE_ASSET__Bp$JIJYE__"